import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { Card } from '../card/card'
import { CardContainer } from '../card/card-container'
import { CardContent } from '../card/card-content'
import { CardHeader } from '../card/card-header'
import AnchorElement from './anchor-element'

import styles from './table-of-contents-element.module.css'

const propTypes = {
    anchor: PropTypes.string,
    anchorName: PropTypes.string,
    className: PropTypes.string,
    containerId: PropTypes.string,
    name: PropTypes.string.isRequired
}

/**
 * Wraps CardContainer Component around the children.
 *
 * @param {object} props - Properties for the container configuration
 * @param {string} props.name - The name for the anchor link
 * @param {string} [props.anchor] - The anchor to scroll to
 * @param {string} [props.anchorName] - The anchorName which differs from the anchor to display another link text
 * @param {string} [props.containerId] - The containerId for the anchor if there is one
 * @returns {ReactElement}
 */
const TableOfContentsElement = props => {
    const { anchor, anchorName, children, className, containerId, name } = props

    return (
        <CardContainer className={cx(styles['container-element'], className, 't3sel-toc-container-element')}>
            <Card className={styles['card-element']}>
                <CardHeader className={styles['card-header']}>
                    <span>{name}</span>
                    {anchor && containerId && <AnchorElement {...{ anchor, anchorName, containerId }} />}
                </CardHeader>
                <CardContent>{children}</CardContent>
            </Card>
        </CardContainer>
    )
}

TableOfContentsElement.propTypes = propTypes

export default TableOfContentsElement
